import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { NumberInput } from '@/components/ui/NumberInput';
import type { Socio } from '@/contabilidad/types';

interface SocioRowProps {
  socio: Socio;
  onChangePorcentaje: (id: number, value: number) => void;
  onChangeNombre: (id: number, value: string) => void;
  onDelete: (id: number) => void;
  readOnly?: boolean;
}

export function SocioRow({ socio, onChangePorcentaje, onChangeNombre, onDelete, readOnly = false }: SocioRowProps) {
  const initials = socio.nombre.trim()
    ? socio.nombre.trim().split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  return (
    <div className="flex items-center gap-3 py-3 border-b last:border-0">
      <div className="size-10 rounded-full bg-primary/10 flex items-center justify-center text-sm font-bold text-primary flex-shrink-0">
        {initials}
      </div>
      <div className="flex-1 min-w-0">
        <Input
          type="text"
          value={socio.nombre}
          onChange={e => onChangeNombre(socio.id, e.target.value)}
          placeholder="Nombre del socio"
          className="h-8 text-sm font-semibold"
          disabled={readOnly}
        />
        {socio.alias && <p className="text-xs text-muted-foreground mt-1">{socio.alias}</p>}
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <div className="relative w-24">
          <NumberInput
            id="monto"
            decimals={2}
            min={0}
            max={100}
            value={socio.porcentaje}
            onChange={(value) => onChangePorcentaje(socio.id, Number(value || 0))}
            className="h-8 text-sm text-right pr-7"
            disabled={readOnly}
          />

          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">%</span>
        </div>
        {!readOnly && (
          <Button
            size="sm"
            variant="ghost"
            className="h-8 w-8 p-0 text-muted-foreground hover:text-gray-900"
            onClick={() => onDelete(socio.id)}
          >
            <Trash2 className="size-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
